import type React from 'react';
import type { LayoutSize } from '../../post/utils/useLayoutSize';
import useLayoutSize, {
  isBelowLayoutSize,
} from '../../post/utils/useLayoutSize';

interface EnsureMinSizeProps {
  children: React.ReactNode;
  minSize?: LayoutSize;
  fallback?: React.ReactNode;
}

const EnsureMinSize = ({ children, minSize, fallback }: EnsureMinSizeProps) => {
  const layoutSize = useLayoutSize();
  const shouldShowFallback =
    !!layoutSize &&
    !!minSize &&
    !!fallback &&
    isBelowLayoutSize(layoutSize, minSize);

  return shouldShowFallback ? fallback : children;
};

export default EnsureMinSize;
